import { useQuery } from '@tanstack/react-query';
import type { LngLat } from '@/planner/types';
import { bboxKey, dtmBbox, fetchDtm, type RasterDtm } from './cuzk';

/** The terrain under a polygon (and takeoff point) padded by `padM` metres, one raster per snapped bounding box. */
export function useDtm(points: LngLat[], padM: number): { dtm: RasterDtm | null; isPending: boolean } {
  const enabled = points.length >= 3;
  const bbox = enabled ? dtmBbox(points, padM) : null;
  const q = useQuery({
    queryKey: ['dtm', bbox ? bboxKey(bbox) : ''],
    queryFn: () => (bbox ? fetchDtm(bbox) : null),
    enabled,
    staleTime: Infinity,
    gcTime: 10 * 60_000,
    retry: false,
  });
  return { dtm: q.data ?? null, isPending: enabled && q.isPending };
}
